import { useState } from 'react';

import { MDText } from 'i18n-react';

import { MoneyStackIcon } from '@motorway/mw-highway-code';

import { ReferAFriend } from '../ReferAFriend/ReferAFriend';

import { ActionTile } from './ActionTile';
import LocalTexts from './ActionTiles.texts.json';

import styles from './ReferActionTile.module.scss';

const LocalT = new MDText(LocalTexts.refer);

type ReferActionTileProps = {
  mentionMeSituation?: string;
  onClick?: () => void;
};

export const ReferActionTile = ({ mentionMeSituation, onClick }: ReferActionTileProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleClick = () => {
    onClick?.();

    if (!mentionMeSituation) {
      return;
    }

    setIsOpen(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const handleClose = () => setIsOpen(false);

  return <>
    <a className={styles.referActionTile} onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
      <ActionTile icon={MoneyStackIcon} text={LocalT.translate('text')} title={LocalT.translate('title')} />
    </a>
    {mentionMeSituation && <ReferAFriend {...{ isOpen }} onClose={handleClose} situation={mentionMeSituation} />}
  </>;
};
